import Vue from "vue";
import CXMApiClient from '../../CXMApiClient';
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
function initialLoad() {
  return {
    ChangeLogData: [],
    CurrentChangelogPage: 1,
    CurrentPagelogSize: 25,
    ChangelogPagination: {
      pageTotal: 0,
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0
    },

    DealsheetData: [],
    DealsheetPagination: {
      pageTotal: 0,
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0
    },
    CurrentDealhistoryPage: 1,
    CurrentDealhistorySize: 25,


  }
}

const state = initialLoad();

const actions = {
  loadChangeLog: function (context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(await client.ProcessRequest('post', '/crm/contacts/' + request.ContactId + '/change_log', request.RequestPayload, scope).then(response => {
        if (response && response.data.successful) {
          context.commit('updateChangeLogData', response.data.data);
          context.commit('updateChangelogPagination', response.data.pageData);
        } else {
          reject(response);
        }
      }).catch(err => {
        reject(err)
      }))
    });
  },
  updateChangelogPagination: function (context, pagination) {
    context.commit('updateChangelogPagination', pagination);
  },
  updateChangelogCurrentPage: function (context, page) {
    context.commit('updateChangelogCurrentPage', page);
  },
  updateChangelogCurrentSize: function (context, size) {
    context.commit('updateChangelogCurrentSize', size);
  },
  updateChangelogData: function (context, data) {
    context.commit('updateChangeLogData', data);
  },

  loadDealsheet: function (context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(await client.ProcessRequest('post', '/crm/contacts/' + request.ContactId + '/dealsheet_history', request.RequestPayload, scope).then(response => {
        if (response && response.data.successful) {
          context.commit('updateDealsheetData', response.data.data);
          context.commit('updateDealsheetPagination', response.data.pageData);
        } else {
          reject(response);
        }
      }).catch(err => {
        reject(err)
      }))
    });
  },
  updateDealsheetData: function (context, data) {
    context.commit('updateDealsheetData', data);
  },
  updateDealsheetPagination: function (context, pagination) {
    context.commit('updateDealsheetPagination', pagination);
  },
  updateDealHistoryCurrentPage: function (context, page) {
    context.commit('updateDealHistoryCurrentPage', page);
  },
  updateDealHistoryCurrentSize: function (context, size) {
    context.commit('updateDealHistoryCurrentSize', size);
  },
};

const mutations = {

  updateChangeLogData: function (state, data) {
    state.ChangeLogData = data;
  },
  updateChangelogPagination: function (state, pagination) {
    state.ChangelogPagination = pagination;
  },
  updateChangelogCurrentPage: function (state, page) {
    state.CurrentChangelogPage = page;
  },
  updateChangelogCurrentSize: function (state, size) {
    state.CurrentPagelogSize = size
  },

  updateDealsheetData: function (state, data) {
    // data = [{
    //     "alertChanged": true,
    //     "mappingChanged": true,
    //     "paymentChanged": true,
    //     "termChanged": true,
    //     "changeDate": "2020-01-09T17:53:12.155Z",
    //     "replacementVehicle": {
    //       "vehicleType": "",
    //       "makeModel": "Ford F-150",
    //       "year": 2019,
    //       "odometer": 0,
    //       "trimName": "Diesel 4wd",
    //       "paymentRemaining": 0,
    //       "payment": 0,
    //       "isNew": true,
    //       "imageUrl": "",
    //       "totalPayments": 0,
    //       "monthlyRate": 0,
    //       "retail": "",
    //       "ro": "",
    //       "roDate": "2020-01-09T17:53:12.155Z",
    //       "status": "",
    //       "saleType": "",
    //       "overMileagePenalty": 0,
    //       "estimatedOverMileagePenalty": 0,
    //       "estimatedMaturityMileage": 0,
    //       "leaseTotalAllowedMiles": 0
    //     },
    //     "term": 2,
    //     "payment": 450,
    //     "isAlert": true,
    //     "isFlexAlert": true,
    //     "isConversionAlert": true,
    //     "isMileageAlert": true,
    //     "isWarrantyAlert": true,
    //     "isContractEnd": true,
    //     "isInMarket": true,
    //     "isInMarketEngaged": true,
    //     "isService": true,
    //     "isAppointment": true
    //   },
    //   {
    //     "alertChanged": false,
    //     "mappingChanged": true,
    //     "paymentChanged": true,
    //     "termChanged": true,
    //     "changeDate": "2020-01-09T17:53:12.155Z",
    //     "replacementVehicle": {
    //       "vehicleType": "",
    //       "makeModel": "Honda Civic",
    //       "year": 2019,
    //       "odometer": 0,
    //       "trimName": "Diesel 4wd",
    //       "paymentRemaining": 0,
    //       "payment": 0,
    //       "isNew": true,
    //       "imageUrl": "",
    //       "totalPayments": 0,
    //       "monthlyRate": 0,
    //       "retail": "",
    //       "ro": "",
    //       "roDate": "2020-01-09T17:53:12.155Z",
    //       "status": "",
    //       "saleType": "",
    //       "overMileagePenalty": 0,
    //       "estimatedOverMileagePenalty": 0,
    //       "estimatedMaturityMileage": 0,
    //       "leaseTotalAllowedMiles": 0
    //     },
    //     "term": 2,
    //     "payment": 100,
    //     "isAlert": true,
    //     "isFlexAlert": true,
    //     "isConversionAlert": true,
    //     "isMileageAlert": false,
    //     "isWarrantyAlert": false,
    //     "isContractEnd": true,
    //     "isInMarket": true,
    //     "isInMarketEngaged": true,
    //     "isService": true,
    //     "isAppointment": true
    //   }
    // ];
    state.DealsheetData = data;
  },
  updateDealsheetPagination: function (state, pagination) {
    state.updateDealsheetPagination = pagination;
  },
  updateDealHistoryCurrentPage: function (state, page) {
    state.CurrentDealhistoryPage = page;
  },
  updateDealHistoryCurrentSize: function (state, size) {
    state.CurrentDealhistorySize = size
  },


};

const getters = {

};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/ChangeLog.js